import { reactive } from 'vue'

// EXPORTING AS REACTIVE
export const state = reactive({
    appSettings: {},
    currentTime: {},
    widgetSettings: [],

    getAppSettings() {
        return this.appSettings;
    },

    setAppSettings(settings) {
        this.appSettings = settings;
    },

    getCurrentTime() {
        return this.currentTime;
    },

    setCurrentTime(currentTime) {
        this.currentTime = currentTime;
    },

    getWidgetSettings() {
        return this.widgetSettings;
    },

    setWidgetSettings(widgetSettings) {
        this.widgetSettings = widgetSettings;
    },

});